import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-pre-arranged-roadmap',
  templateUrl: './pre-arranged-roadmap.component.html',
  styleUrls: ['./pre-arranged-roadmap.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PreArrangedRoadmapComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  
}



// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/crm/components/screens/my-company/pre-arranged-roadmap/pre-arranged-roadmap.component.ts